<div class="tooltip-box" [style.left]="moveToLeft ? '-350px' : ''">
  <div class="table-container">
    <table class="table-header no-top-border" style="width: 100%">
      <colgroup>
        <col *ngFor="let col of tableHeader" [width]="col.width"/>
      </colgroup>
      <thead>
        <tr>
          <th *ngFor="let header of tableHeader"> 
            <div>{{header.name}}</div>
          </th>
        </tr>
      </thead>
    </table>
    <div class="table-body">
      <table>  
        <colgroup>
          <col *ngFor="let col of tableHeader" [width]="col.width"/>
        </colgroup>
        <tbody>
          <tr>
            <td>Talk Down</td>
            <td> 
              <div class="status" *ngIf="!isLoading">
                <div class="badge" [ngClass]="currentDealerPlan != 1 || sitePlan != 1 ? 'enabled' : 'disabled'">{{ showTTSPlanData() }}</div>
              </div>
            </td>
            <td> 
              <div *ngIf="currentDealerPlan != 1 || sitePlan != 1">Available</div>
              <div *ngIf="currentDealerPlan === 1 && sitePlan === 1"> 
                <ng-container *ngIf="isHasViewInvoicePermission">{{usersService.me().currency_symbol}} {{ ttsPlanData.price }}/ mo</ng-container>
                <ng-container *ngIf="!isHasViewInvoicePermission">Available</ng-container>
              </div>
            </td>
          </tr>
          <tr>
            <td>Remote Access</td>
            <td> 
              <div class="status" *ngIf="!isLoading">
                <div class="badge" [ngClass]="currentDealerPlan != 1 || sitePlan != 1 ? 'enabled' : 'disabled'">{{ showRemoteAccessData() }}</div>
              </div>
            </td>
            <td>
              <div *ngIf="currentDealerPlan != 1 || sitePlan != 1">Available</div>
              <div *ngIf="currentDealerPlan === 1 && sitePlan === 1"> 
                <ng-container *ngIf="isHasViewInvoicePermission">{{usersService.me().currency_symbol}} {{ remoteAccessPlanData.price }}/ mo</ng-container>
                <ng-container *ngIf="!isHasViewInvoicePermission">Available</ng-container>
              </div>
            </td>
          </tr>
          <tr>
            <td>Video Events</td>
            <td> 
              <ng-container *ngIf="!isLoading">
                <ng-template [ngIf]="sitePlan > 2" [ngIfElse]="elseBlock">
                  <div class="status" style="font-size: 12px">✅  Unlimited events</div>
                </ng-template>
                <ng-template #elseBlock>
                  <div class="status">
                    {{servicePricing?.videoEvent?.free_package_amount?.event}} free events <br/>{{usersService.me().currency_symbol}}{{servicePricing?.videoEvent?.paid_package_amount?.price}} / {{servicePricing?.videoEvent?.paid_package_amount?.event}} events</div>
                </ng-template>
              </ng-container>
            </td>
            <td> 
              <ng-template [ngIf]="sitePlan > 2" [ngIfElse]="elseBlock">Available</ng-template>
              <ng-template #elseBlock>-</ng-template>
            </td>
          </tr>
          <tr>
            <td>Cloud AI</td>
            <td> 
              <ng-container *ngIf="!isLoading">
                <ng-container *ngIf="!isEnabledCloudAIDealerLevel && !isEnabledCloudAISiteLevel">
                  <div class="status disabled">N/A</div>
                </ng-container>
                <ng-container *ngIf="isEnabledCloudAIDealerLevel && !isEnabledCloudAISiteLevel">
                  <div class="status">Needs to be enabled at the Site Level</div>
                </ng-container>
                <ng-container *ngIf="isEnabledCloudAIDealerLevel && isEnabledCloudAISiteLevel">
                  <div class="status" style="flex-direction: row;flex-wrap: wrap;justify-content: end;">
                    <div class="badge enabled">Enabled</div>
                    <div>{{ enabledCloudAICameraNumber }} cameras in use</div>
                  </div>
                  <ng-template [ngIf]="currentDealerPlan > 1 && sitePlan === 4" [ngIfElse]="elseBlock">
                    <div style="font-size: 12px">✅ Unlimited Cloud AI Usage</div>
                  </ng-template>
                  <ng-template #elseBlock>
                    <div style="font-size: 12px; margin-top: 4px">Charges based Dealer Usage</div>
                  </ng-template>
                </ng-container>
              </ng-container>
            </td>
            <td> 
              <div *ngIf="(currentDealerPlan != 1 || sitePlan === 4) && hasCHeKTBridge">Available</div>
              <div *ngIf="(currentDealerPlan === 1 && sitePlan != 4) && hasCHeKTBridge">Requires Plan Upgrade</div>
              <div *ngIf="!hasCHeKTBridge">Requires CHeKT Bridge</div>
            </td>
          </tr>
          <tr>
            <td>Cloud VMS Services</td>
            <td> 
              <div class="status" *ngIf="!isLoading">
                <div class="site-plan-badge" [ngClass]="computedSitePlanBadge()">{{ computedSitePlanName() }}</div>
              </div>
            </td>
            <td> 
              <div *ngIf="sitePlan === 1">N/A</div>
              <div *ngIf="sitePlan != 1"> 
                <ng-container *ngIf="isHasViewInvoicePermission">{{usersService.me().currency_symbol}} {{ showSitePlanPrice() }}/ mo</ng-container>
                <ng-container *ngIf="!isHasViewInvoicePermission">Available</ng-container>
              </div>
            </td>
          </tr>
          <tr *ngIf="sitePlan != 1">
            <td>On-Board Device Storage Access</td>
            <td> 
              <div class="status" *ngIf="!isLoading">
                <div class="badge enabled">Included</div>
              </div>
            </td>
            <td> 
              <div>Available</div>
            </td>
          </tr>
          <tr *ngIf="sitePlan != 1">
            <td>24/7 Cloud-Based Event Recording</td>
            <td> 
              <div class="status" *ngIf="!isLoading">
                <div class="badge enabled">Included</div>
              </div>
            </td>
            <td> 
              <div>Available</div>
            </td>
          </tr>
          <tr *ngIf="sitePlan != 1">
            <td>Time-Lapse Recording</td>
            <td> 
              <div class="status" *ngIf="!isLoading">
                <div class="badge enabled" *ngIf="sitePlan > 2">Included</div>
                <div class="badge disabled" *ngIf="sitePlan < 3">Disabled</div>
              </div>
            </td>
            <td> 
              <div *ngIf="sitePlan > 2">Available</div>
              <div *ngIf="sitePlan < 3">Requires Site Plan Upgrade</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>